export const LOCAL_STORAGE_NO_SHOW_KEY = 'adv-popup-no-show';
